export default interface StudyFormData {
    id?: number;
    title: string;
    description: string;
    ethic: string;
    school_study: boolean;
    school_name: string;
    school_postcode?: string;
    school_category: "single-sex-male" | "single-sex-female" | "co-educational";
    ethnic_info: string;
    SES_info: string;
    yr_level: string;
    other_info: string;
    active: boolean;
    created: boolean;
    properties: boolean;
    questions: boolean;
    demographics: boolean;
    intro_consent: boolean;
    base: boolean;
    constant: boolean;
    group: any;
    measures: any[]; 
    cohort_items: any[]; 
    individual_items: any[];
    demographic?: any;
  }

export interface EditStudyFormData {
    id: number;
    title: string;
    description: string;
    ethic: string;
    school_study: boolean;
    school_name: string;
    school_postcode: number;
    school_category: string;
    ethnic_info: string;
    SES_info: string;
    yr_level: string;
    other_info: string;
    active: boolean;
    created: boolean;
    properties: boolean;
    questions: boolean;
    demographics: boolean;
    intro_consent: boolean;
    base: boolean;
    constant: boolean;
    created_at: string;
    updated_at: string;
    group: number;
    measures: number[];
    cohort_items: any[];
    individual_items: number[];
  }

  export const defaultStudyFormData: StudyFormData = {
    id: undefined,
    title: "",
    description: "",
    ethic: "",
    school_study: false,
    school_name: "",
    school_postcode: "",
    school_category: "co-educational",
    ethnic_info: "",
    SES_info: "",
    yr_level: "",
    other_info: "",
    created: false,
    properties: false,
    group: "",
    measures: [],
    cohort_items: [],
    individual_items: [],
    active: false,
    questions: false,
    demographics: false,
    intro_consent: false,
    base: false,
    constant: false
  };